import { spawn } from 'redux-saga/effects'

import watchIsFailedRequestUnauthorized from './watchIsFailedRequestUnauthorized'
import watchLogin from './watchLogin'
import watchLogout from './watchLogout'
import watchOrganizationSwitch from './watchOrganizationSwitch'
import watchRequestUnauthorized from './watchRequestUnauthorized'

export { default as watchLogin } from './watchLogin'
export { default as watchLogout } from './watchLogout'

export default function* root() {
  yield spawn(watchLogout)
  yield spawn(watchLogin)
  yield spawn(watchRequestUnauthorized)
  yield spawn(watchOrganizationSwitch)
  yield spawn(watchIsFailedRequestUnauthorized)
}
